import request from "./api";
/* 查询埋点 */

// 单项训练
export const getIndividualAnswer = (params) =>
  request(`/api-score/study/single-compare-result`, params,{
    contentType: "application/x-www-form-urlencoded"
  });
// 综合实训
export const post_complex_score_compare_select = (params, opts) =>
  request('/api-score/complex-score-compare-select', params, {
    ...opts,
    method: 'post'
  });



// WEBPACK FOOTER //
// ./src/api/answerCompare.js